"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
var React = require("react");
var Icon_1 = require("../Icon");
var classnames = require("classnames");
var LoadingSpinner = function (props) { return (React.createElement(Icon_1.Icon, { className: classnames('fas', 'fa-spinner', 'fa-spin', 'sok-loading-spinner', props.className), prefix: 'far' })); };
exports.LoadingSpinner = LoadingSpinner;
//# sourceMappingURL=index.js.map